import React from 'react';
import { Sparkles, CalendarClock, Tv2, Play, Heart, Star } from 'lucide-react';

const TAG_ICON = {
  premiere: Sparkles,
  new_season: Sparkles,
  new_episode: Play,
  airs_today: Play,
  airs_soon: CalendarClock,
  in_production: Tv2,
  rediscovered: Heart,
  popular: Star,
};

const TAG_TONE = {
  premiere: 'tone-hot',
  new_season: 'tone-hot',
  new_episode: 'tone-warm',
  airs_today: 'tone-warm',
  airs_soon: 'tone-cool',
  in_production: 'tone-cool',
  rediscovered: 'tone-soft',
  popular: 'tone-soft',
};

const TrendingReasonChip = ({ reason, size = 'sm', className = '' }) => {
  if (!reason || !reason.label) return null;
  const Icon = TAG_ICON[reason.tag] || Star;
  const tone = TAG_TONE[reason.tag] || 'tone-soft';
  return (
    <span
      className={`reason-chip ${tone} size-${size} ${className}`}
      data-testid={`trending-reason-${reason.tag}`}
      title={reason.label}
    >
      <Icon size={size === 'lg' ? 14 : 12} className="reason-icon" />
      <span className="reason-label">{reason.label}</span>

      <style jsx>{`
        .reason-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.35rem;
          padding: 0.25rem 0.6rem;
          border-radius: 999px;
          font-weight: 700;
          letter-spacing: 0.02em;
          line-height: 1;
          border: 1px solid transparent;
          white-space: nowrap;
        }
        .size-sm {
          font-size: 0.7rem;
        }
        .size-lg {
          font-size: 0.78rem;
          padding: 0.35rem 0.75rem;
        }
        .tone-hot {
          background: linear-gradient(120deg, rgba(230, 47, 136, 0.22), rgba(245, 185, 66, 0.16));
          color: #ffb6d5;
          border-color: rgba(230, 47, 136, 0.45);
        }
        .tone-warm {
          background: rgba(230, 47, 136, 0.14);
          color: #ff8ec0;
          border-color: rgba(230, 47, 136, 0.3);
        }
        .tone-cool {
          background: rgba(96, 165, 250, 0.12);
          color: #93c5fd;
          border-color: rgba(96, 165, 250, 0.28);
        }
        .tone-soft {
          background: rgba(255, 255, 255, 0.04);
          color: #d4d4d8;
          border-color: rgba(255, 255, 255, 0.08);
        }
        .reason-icon {
          flex-shrink: 0;
        }
        .reason-label {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </span>
  );
};

export default TrendingReasonChip;
